import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Form, Row, Container, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { DOCTOR_ADDRESS, DOCTOR_EMAIL_ADDRESS, IMAGE_URL, USER_BASE_URL } from "../../API";
import { AiOutlineMail } from "react-icons/ai";
import { LuPhone } from "react-icons/lu";
import { FiEdit } from "react-icons/fi";
import { useForm } from "react-hook-form";
import Header2 from "../../components/Header2";
import avtar from "../../Assets/Images/image copy 2.png"
import { ProfileContext } from "../../context/ProfileContext";
import { IoMdCloseCircle } from "react-icons/io";
import { MdOutlineLocationOn } from "react-icons/md";

import axios from "axios";
import { toast } from "react-toastify";

function Profile() {
  const [showDoctorModal, setShowDoctorModal] = useState(false);
  const [newDoctor, setNewDoctor] = useState({
    name: "",
    email: ""
  });
  const [Error, setError] = useState("");
  const [uploading, setUploading] = useState(false);

  const navigate = useNavigate();
  const { profile, headers, editBasicInfo, keyHandler, allDoctors, fetchaData } = useContext(ProfileContext);
  const { register, handleSubmit, formState: { errors }, reset, setValue, clearErrors } = useForm({ defaultValues: profile });
  function handlechanges() { navigate('/edit-profile') }
  const toggleDoctorModal = () => { setShowDoctorModal(!showDoctorModal); setError("") };

  useEffect(() => { fetchaData() }, [])

  useEffect(() => {
    if (profile) {
      reset(profile);
      if (profile.bloodGroup) { clearErrors('bloodGroup'); }
      if (profile.dob) { clearErrors("dob"); }
    }
  }, [profile, reset, setValue, clearErrors]);

  const submitDoctorRequest = async () => {
    if (!newDoctor.name) { setError("Please enter doctor name."); return }
    if (!newDoctor.email) { setError("Please enter doctor email."); return }

    try {
      const payload = { name: newDoctor.name, email: newDoctor.email, };
      const response = { data: { code: 200 } }
      await axios.post(USER_BASE_URL + DOCTOR_EMAIL_ADDRESS, payload, { headers });

      if (response.data.code === 200) {
        toast.success(response.data.message);
        setShowDoctorModal(false);
        setNewDoctor({ name: "", email: "" });
        fetchaData();
      }
    }
    catch (error) {
      toast.error(error?.response?.data?.message || "Doctor request failed. Please try again.");
    }
  };

  return (
    <>

      <div className="comm_page_outer">
        <Container>
          <Header2 />
          <div className="comm_inner_page_layout">
            <section className="comm_form_border_box_row">
              <div className="comm_border_box">
                <div className="profile_main_page">
                  <div className="d-flex my_profile_row">
                    <div className="comm_profile_head_usr_detail">
                      <div className="profile-pic">
                        <Form.Control id="file" type="file" name="profile_picture" />
                        <figure className="profile-img-edit">
                          <img src={profile.image ? `${IMAGE_URL}${profile.image}` : avtar} alt="User" className="img-fluid" />
                        </figure>
                      </div>
                      <div className="name-all">
                        <h6>{profile.full_name}</h6>
                        <p><AiOutlineMail /> {profile.email}</p>
                        <p><LuPhone /> {profile.number}</p>
                        <p className="text-capitalize"><MdOutlineLocationOn size={18} />{profile.address}</p>
                      </div>
                    </div>

                    <div className="comm-pair-btns d-flex align-items-center gap-3">
                      <button onClick={handlechanges} className="main-btn comm_icon_btn edit_profile_btn"><FiEdit /> Edit Profile</button>
                      <Link to="/change-password" className="main-outline-btn">Change Password</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="comm_border_box">
                <Form className="comm_form" onSubmit={handleSubmit(editBasicInfo)}>
                  <h4 className="comm_inner_form_heading">Provide basic information</h4>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Date of Birth</Form.Label>
                        <div className="cst_datepicker_outer">
                          <Form.Control
                            type="date"
                            placeholder="Enter Your Date of Birth"
                            {...register('dob', {
                              required: 'Please select DOB.',
                              validate: (value) => {
                                const selectedDate = new Date(value);
                                const currentDate = new Date();
                                selectedDate.setHours(0, 0, 0, 0);
                                currentDate.setHours(0, 0, 0, 0);
                                return selectedDate < currentDate || 'Date of birth cannot be today or in the future.';
                              }
                            })}
                            defaultValue={profile?.dob}
                            onChange={(e) => { setValue('dob', e.target.value) }}
                            onClick={(e) => e.target.showPicker()}
                          />
                        </div>
                        {errors.dob && <span className="error">{errors.dob.message}</span>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Blood Group</Form.Label>
                        <Form.Select
                          {...register('blood_group', { required: 'Please select blood group.' })}
                          defaultValue={profile?.bloodGroup || ''}
                          onChange={(e) => {
                            setValue('blood_group', e.target.value);
                            clearErrors('blood_group');
                          }}
                        >
                          <option value="">Select</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="O-">O-</option>
                          <option value="O+">O+</option>
                        </Form.Select>
                        {errors.blood_group && <span className="error">{errors.blood_group.message}</span>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Gender</Form.Label>
                        <Form.Select
                          {...register('gender', { required: 'Please select gender.' })}
                          defaultValue={profile?.gender || ''}
                          onChange={(e) => {
                            setValue('gender', e.target.value);
                            clearErrors('gender');
                          }}
                        >
                          <option value="">Select</option>
                          <option value="male">Male</option>
                          <option value="female">female</option>
                          <option value="others">others</option>
                        </Form.Select>
                        {errors.gender && <span className="error">{errors.gender.message}</span>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Age</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Your Age"
                          onKeyDown={(e) => keyHandler(e, false)}
                          {...register('age', { required: 'Please enter age.', })}
                        />
                        {errors.age && <span className="error">{errors.age.message}</span>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Height (cms)</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Your Height"
                          onKeyDown={(e) => keyHandler(e, false)}
                          {...register('height', { required: 'Please enter height.', })}
                        />
                        {errors.height && <span className="error">{errors.height.message}</span>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Weight (Kgs)</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Your Weight"
                          onKeyDown={(e) => keyHandler(e, false)}
                          {...register('weight', { required: 'Please enter weight', min: { value: 1, message: 'Weight must be greater than 0' } })}
                        />
                        {errors.weight && <span className="error">{errors.weight.message}</span>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Primary Care Provider</Form.Label>
                        {/* <Form.Control
                          type="text"
                          placeholder="Enter Your Primary Care Provider"
                          {...register('primary_care_provider', {
                            required: 'Please enter primary care provider.',
                            validate: value => value.trim() !== '' || 'Primary care provider cannot be empty or only spaces.',
                          })}
                        /> */}
                        <Form.Select {...register('primary_care_provider', { required: 'Please select a primary care provider.', })}
                          onChange={(e) => {
                            if (e.target.value === "") {
                              setShowDoctorModal(true);
                              setValue('primary_care_provider', '');
                            } else {
                              setValue('primary_care_provider', e.target.value);
                              clearErrors('primary_care_provider');
                            }
                          }}
                        >
                          <option value="" disabled>Select Your Primary Care Provider</option>.
                          {allDoctors.map((doctor) => (
                            <option key={doctor._id} value={doctor._id}>{doctor.name}</option>
                          ))}
                          <option value=''>Not listed</option>
                        </Form.Select>
                        {errors.primary_care_provider && <span className="error">{errors.primary_care_provider.message}</span>}
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="comn-class-inputs">
                        <Form.Label>Pharmacy</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Your Pharmacy"
                          {...register('pharmacy', {
                            required: 'Please enter pharmacy.',
                            validate: value => value.trim() !== '' || 'Pharmacy cannot be empty or only spaces.',
                          })}
                        />
                        {errors.pharmacy && <span className="error">{errors.pharmacy.message}</span>}
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="dash-pair-btns-comn comm_form_same_sz_btns d-flex align-items-center gap-3 mt-5">
                    <Link to="/profile-page" className="main-outline-btn cancel" >Back</Link>
                    <button className="main-btn profile_form_comm_btn mt-0" type="submit">Next</button>
                  </div>
                </Form>
              </div>
            </section>
          </div>
        </Container>
      </div>
      <Modal
        show={showDoctorModal}
        onHide={toggleDoctorModal}
        centered
        className="comm_modal logout_modal"
      >
        <Modal.Body className="p-0">
          <Modal.Header>
            <IoMdCloseCircle onClick={toggleDoctorModal} />
          </Modal.Header>

          <div className="comm_inner_body_modal px-5">
            <h4> Doctor not listed? </h4>
            <p>Please enter doctor details below</p>

            <Row>
              <Col md={12}>
                <Form.Group className="comn-class-inputs">
                  <Form.Label>Doctor Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter doctor name"
                    value={newDoctor.name}
                    onChange={(e) =>
                      setNewDoctor({ ...newDoctor, name: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group className="comn-class-inputs">
                  <Form.Label>Doctor Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter doctor email"
                    value={newDoctor.email}
                    onChange={(e) =>
                      setNewDoctor({ ...newDoctor, email: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            {Error && <span className="error">{Error}</span>}

            <div className="modal_pair_btns">
              <button
                className="main-outline-btn"
                onClick={toggleDoctorModal}
                disabled={uploading}
              >
                No
              </button>

              <button
                className="main-btn"
                onClick={submitDoctorRequest}
                disabled={uploading}
              >
                {uploading ? "Submitting..." : "Yes"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Profile;